import { TGlobalConfigContextState } from "./GlobalConfigContext"

export const globalConfigSelectors = {
  dictionaries: (state: TGlobalConfigContextState) => state.dictionaries,
  webhookEvents: (state: TGlobalConfigContextState) => state.webhookEvents,
  userGroups: (state: TGlobalConfigContextState) => state.userGroups,
  update: (state: TGlobalConfigContextState) => state.update,
}
